import React, { createContext, useContext, useState } from "react";

interface SelectionContextType {
  selectedBuilding: string | null;
  selectedApartment: string | null;
  saveSelection: (building: string, apartment: string) => void;
}

const SelectionContext = createContext<SelectionContextType | undefined>(undefined);

export const SelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedBuilding, setSelectedBuilding] = useState<string | null>(null);
  const [selectedApartment, setSelectedApartment] = useState<string | null>(null);

  const saveSelection = (building: string, apartment: string) => {
    setSelectedBuilding(building);
    setSelectedApartment(apartment);
  };

  return (
    <SelectionContext.Provider value={{ selectedBuilding, selectedApartment, saveSelection }}>
      {children}
    </SelectionContext.Provider>
  );
};

export const useSelectionContext = () => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error("useSelectionContext must be used within a SelectionProvider");
  }
  return context;
};
